import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useRole } from "components/Hooks/UserHooks";
import { isHavePermissionRole, ROLES_FOR_APP } from "helpers/role";
import { useTranslation } from "react-i18next";
import { ROUTES } from "routes/allRoutes";
import FeatherIcon from "feather-icons-react";

const Navdata = () => {
  const history = useNavigate();
  const { t } = useTranslation();

  const { userPermissions } = useRole();

  const [menuActive, setMenuActive] = useState<string>("DASHBOARD");

  const [isCurrentState, setIsCurrentState] = useState("Dashboard");

  function updateIconSidebar(e: any) {
    if (e && e.target && e.target.getAttribute("sub-items")) {
      const ul: any = document.getElementById("two-column-menu");
      const iconItems = ul.querySelectorAll(".nav-icon.active");
      let activeIconItems = [...iconItems];
      activeIconItems.forEach((item) => {
        item.classList.remove("active");
        var id = item.getAttribute("sub-items");
        const getID = document.getElementById(id) as HTMLElement;
        if (getID) getID.classList.remove("show");
      });
    }
  }

  useEffect(() => {
    document.body.classList.remove("twocolumn-panel");
  }, [history]);

  const menuItems: any = [
    {
      id: "company-management",
      label: t("Company Management"),
      icon: <i className="ri ri-building-2-line" />,
      link: ROUTES.COMPANY_MANAGEMENT,
      click: function (e: any) {
        setMenuActive((prev) => "COMPANY_MANAGEMENT");
        setIsCurrentState((prev) => "Company Management");
        updateIconSidebar(e);
      },
      stateVariables: menuActive === "COMPANY_MANAGEMENT",
      isShow: isHavePermissionRole(
        [ROLES_FOR_APP.COMPANY_MANAGEMENT],
        userPermissions
      ),
    },
    {
      id: "user-management",
      label: t("User Management"),
      icon: <FeatherIcon icon="users" className="icon-dual" />,
      link: ROUTES.USER_MANAGEMENT,
      click: function (e: any) {
        setMenuActive((prev) => "USER_MANAGEMENT");
        setIsCurrentState((prev) => "User Management");
        updateIconSidebar(e);
      },
      stateVariables: menuActive === "USER_MANAGEMENT",
      isShow: isHavePermissionRole(
        [ROLES_FOR_APP.USER_MANAGEMENT],
        userPermissions
      ),
    },
    {
      id: "application-management",
      label: t("Application Management"),
      icon: <i className="ri-user-star-line" />,
      link: ROUTES.APPLICATION_MANAGEMENT,
      click: function (e: any) {
        setMenuActive((prev) => "APPLICATION_MANAGEMENT");
        setIsCurrentState((prev) => "Application Management");
        updateIconSidebar(e);
      },
      stateVariables: menuActive === "APPLICATION_MANAGEMENT",
      isShow: isHavePermissionRole(
        [ROLES_FOR_APP.APPLICATION_MANAGEMENT],
        userPermissions
      ),
    },
    {
      id: "operator-management",
      label: t("Operator Management"),
      icon: <i className="ri-user-add-line" />,
      link: ROUTES.OPERATOR_LIST,
      click: function (e: any) {
        setMenuActive((prev) => "OPERATOR_LIST");
        setIsCurrentState((prev) => "Operator Management");
        updateIconSidebar(e);
      },
      stateVariables: menuActive === "OPERATOR_LIST",
      isShow: isHavePermissionRole(
        [ROLES_FOR_APP.OPERATOR_LIST],
        userPermissions
      ),
    },
    {
      id: "audition-management",
      label: t("Audition Management"),
      icon: <i className="ri ri-mic-2-line" />,
      link: ROUTES.AUDITION_MANAGEMENT,
      click: function (e: any) {
        setMenuActive((prev) => "AUDITION_MANAGEMENT");
        setIsCurrentState((prev) => "Audition Management");
        updateIconSidebar(e);
      },
      stateVariables: menuActive === "AUDITION_MANAGEMENT",
      isShow: isHavePermissionRole(
        [ROLES_FOR_APP.AUDITION_MANAGEMENT],
        userPermissions
      ),
    },
    {
      id: "inquiry",
      label: t("Inquiry Management"),
      icon: <i className="ri-wechat-line" />,
      link: ROUTES.INQUIRY_LIST,
      click: function (e: any) {
        setMenuActive((prev) => "Inquiry");
        setIsCurrentState((prev) => "Inquiry");
        updateIconSidebar(e);
      },
      stateVariables: menuActive === "Inquiry",
      isShow: true,
    },
    {
      id: "category",
      label: t("Category Management"),
      icon: <i className="ri-function-line" />,
      link: ROUTES.CATEGORY_LIST,
      click: function (e: any) {
        setMenuActive((prev) => "CATEGORY_LIST");
        setIsCurrentState((prev) => "CATEGORY_LIST");
        updateIconSidebar(e);
      },
      stateVariables: menuActive === "CATEGORY_LIST",
      isShow: true,
    },
  ];
  return <React.Fragment>{menuItems}</React.Fragment>;
};
export default Navdata;
